(function () {
    'use strict';
    angular.module('app').controller('PopLockersProvidersController', PopLockersProvidersController);
    PopLockersProvidersController.$inject = ['PopLockerProvidersTable'];

    function PopLockersProvidersController(PopLockerProvidersTable) {
        const vm = this;

        init();

        function init() {
            initTable();
        }

        function initTable() {
            vm.providersTable = new PopLockerProvidersTable().tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/PopLockersProvidersController.js